// extracted by mini-css-extract-plugin
export default {"title":"download-progress-modal_title__n4n8g","content":"download-progress-modal_content__w8gq9"};